// extracted by mini-css-extract-plugin
export default {"input":"date-field-module__input--swB"};